import React from 'react';
import {MARGIN_MD, SPAN_FULL, SPAN_ONE_QUARTER, SPAN_THREE_QUARTERS} from "../../../styles/constants";
import {Card, Col, Form, Input, Modal, Row, Select} from "antd";
import {isIDValidWithHelp, isVersionValidWithHelp} from "../../../utils/artefactValidators";
import PerfInput from "../../perf-input";
import {compose} from "redux";
import {translate} from "react-i18next";
import _ from "lodash";
import {ID_MAX_LEN} from "../../../constants/numbers";
import {connect} from "react-redux";
import {changeELDstDataflowForm, readElAgencies} from "../actions";
import {DataLanguageConsumer} from "../../../contexts/DataLanguage";
import {getLocalizedStr} from "../../../middlewares/i18n/utils";
import MultilanguageInput from "../../multilanguage-input";
import Call from "../../../hocs/call";

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
  permissions: state.app.user.permissions,
  dstDataflow: state.scenes.easyLoading.dstDataflow,
  agencies: state.scenes.easyLoading.agencies
});

const mapDispatchToProps = dispatch => ({
  fetchAgencies: allowedAgencies => dispatch(readElAgencies(allowedAgencies)),
  onChange: fields => dispatch(changeELDstDataflowForm(fields))
});

const mapPropsToFields = ({dstDataflow}) => ({
  id: Form.createFormField({value: dstDataflow ? dstDataflow.id : null}),
  agencyID: Form.createFormField({value: dstDataflow ? dstDataflow.agencyID : null}),
  version: Form.createFormField({value: dstDataflow ? dstDataflow.version : null}),
  name: Form.createFormField({value: dstDataflow ? dstDataflow.name : null})
});

const onFieldsChange = (props, fields) => {

  if (props.onChange) {
    const newFields = _.mapValues(fields, ({value}) => value);
    if (newFields.id && newFields.id.length > ID_MAX_LEN) {
      Modal.warning({
        title: props.t('commons.alerts.fieldTooLong.title'),
        content: props.t('commons.alerts.fieldTooLong.content', {maxLen: ID_MAX_LEN})
      });
      props.onChange(props.artefact);
    } else {
      props.onChange(newFields);
    }
  }
};

const formItemLayout = {
  labelCol: {span: SPAN_ONE_QUARTER},
  wrapperCol: {span: SPAN_THREE_QUARTERS}
};

const ELDataForm = ({
                      t,
                      form,
                      appLanguage,
                      dataLanguages,
                      agencies,
                      dstDataflow,
                      fetchAgencies,
                      permissions
                    }) =>
  <Call
    cb={fetchAgencies}
    cbParam={permissions ? permissions.agencies : undefined}
    disabled={agencies !== null}
  >
    <Card type="inner">
      <Form>
        <Row style={{marginBottom: MARGIN_MD}}>
          <Col span={SPAN_FULL}>
            <Form.Item
              className="form-item-required"
              label={t('data.artefact.id.label')}
              validateStatus={dstDataflow && isIDValidWithHelp(t, dstDataflow.id).help ? "warning" : null}
              help={dstDataflow && isIDValidWithHelp(t, dstDataflow.id).help}
              {...formItemLayout}
            >
              {form.getFieldDecorator('id', {
                getValueFromEvent: e => (e || "").toUpperCase()
              })(
                <PerfInput
                  Component={Input}
                  title={form.getFieldValue('id')}
                  style={{textTransform: "uppercase"}}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row style={{marginBottom: MARGIN_MD}}>
          <Col span={SPAN_FULL}>
            <DataLanguageConsumer>
              {dataLanguage => {
                const language = dataLanguage || appLanguage;
                return (
                  <Form.Item
                    className="form-item-required"
                    label={t('data.artefact.agencyID.label')}
                    {...formItemLayout}
                  >
                    {form.getFieldDecorator('agencyID')(
                      <Select
                        showSearch
                        filterOption={(inputValue, {props}) =>
                          props.title.toLowerCase().includes(inputValue.toLowerCase())
                        }
                        title={
                          agencies && form.getFieldValue('agencyID') &&
                          (getLocalizedStr((agencies[form.getFieldValue('agencyID')]), language, dataLanguages) || form.getFieldValue('agencyID'))
                        }
                      >
                        {agencies
                          ? Object.keys(agencies).map((agencyID, index) => {

                            const agencyName = getLocalizedStr(agencies[agencyID], language, dataLanguages);

                            return (
                              <Select.Option
                                key={index}
                                value={agencyID}
                                title={agencyID && agencyName ? `${agencyID} - ${agencyName}` : agencyID}
                              >
                                {agencyID && agencyName ? `${agencyID} - ${agencyName}` : agencyID}
                              </Select.Option>
                            );
                          })
                          : null
                        }
                      </Select>
                    )}
                  </Form.Item>
                );
              }}
            </DataLanguageConsumer>
          </Col>
        </Row>
        <Row style={{marginBottom: MARGIN_MD}}>
          <Col span={SPAN_FULL}>
            <Form.Item
              className="form-item-required"
              label={t('data.artefact.version.label')}
              hasFeedback
              validateStatus={dstDataflow && isVersionValidWithHelp(t, dstDataflow.version).help ? "warning" : null}
              help={dstDataflow && isVersionValidWithHelp(t, dstDataflow.version).help}
              {...formItemLayout}
            >
              {form.getFieldDecorator('version')(
                <PerfInput
                  Component={Input}
                  title={form.getFieldValue('version')}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={SPAN_FULL}>
            <Form.Item
              className="form-item-required"
              label={t('data.artefact.name.label')}
              {...formItemLayout}
            >
              {form.getFieldDecorator('name')(
                <PerfInput Component={MultilanguageInput}/>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  </Call>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
)(ELDataForm);


// WEBPACK FOOTER //
// ./src/components/easy-loading/data-step/DataForm.jsx